import { Module } from "@/constants";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import {
  contestAgreementList,
  contestAgreementListFull,
  contestAgreementListFullRestricted,
  contestAgreementListRestricted,
} from "@/schemas/contestAgreement";
import { useMemo } from "react";
import { useContestAgreementsFieldPermissions } from "./useContestAgreementsFieldPermissions";

export function useContestAgreementListSchema() {
  const permissions = useModulePermissions(Module.ContestAgreements);
  const { canSeePresentationImageCount } =
    useContestAgreementsFieldPermissions();

  const hasFullRead = permissions.contest_agreements_read_full;

  const schema = useMemo(() => {
    if (hasFullRead) {
      return canSeePresentationImageCount
        ? contestAgreementListFull
        : contestAgreementListFullRestricted;
    }

    return canSeePresentationImageCount
      ? contestAgreementList
      : contestAgreementListRestricted;
  }, [hasFullRead, canSeePresentationImageCount]);

  return { schema, hasFullRead, canSeePresentationImageCount };
}
